import React from "react";
import PropTypes from "prop-types";
import { Wrapper, Text, Buttons } from "./styles/warning-styles";
import Button from "../../shared/button/Button";

const Warning = ({ toggleWarning, closeForm, field }) => (
  <Wrapper field={field}>
    <Text>
      Any unsaved changes will be <span>lost</span>? <br /> Do you want to{" "}
      <span>continue</span>?
    </Text>
    <Buttons>
      <Button
        secondary
        buttonName="Cancel"
        onClickAction={() => toggleWarning()}
      />
      <Button primary buttonName="Yes" onClickAction={() => closeForm()} />
    </Buttons>
  </Wrapper>
);

Warning.propTypes = {
  toggleWarning: PropTypes.func.isRequired,
  closeForm: PropTypes.func.isRequired,
  field: PropTypes.string,
};

Warning.defaultProps = {
  field: PropTypes.isNull,
};

export default Warning;
